const e=()=>{const e=new URLSearchParams(window.location.search),t=e.get("jobId")||e.get("jobid")||e.get("KId");return`/seeker/job-details?${t?"kId=":"id="}${t||e.get("id")||""}&autoApply=true`};export{e as createJobApplyUrl};
